"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _SliderMixin = require("./SliderMixin");
// Styling based on:
// http://danielstern.ca/range.css/#/
var thumbsCSS = function thumbsCSS(props) {
  return (0, _styledToken.default)('Range.Thumb.boxShadow.focus', function (focusBoxShadow) {
    return (0, _styledComponents.css)(["&::-webkit-slider-thumb{", " -webkit-appearance:none;margin-top:-11px;}&::-moz-range-thumb{", "}&::-ms-thumb{", " height:6px;margin-top:0;}&:focus-visible::-webkit-slider-thumb{box-shadow:", ";}&:focus-visible::-moz-range-thumb{box-shadow:", ";}@supports not selector(:focus-visible){&:focus::-webkit-slider-thumb{box-shadow:", ";}&:focus::-moz-range-thumb{box-shadow:", ";}}"], (0, _SliderMixin.SliderThumbMixin)(props), (0, _SliderMixin.SliderThumbMixin)(props), (0, _SliderMixin.SliderThumbMixin)(props), focusBoxShadow, focusBoxShadow, focusBoxShadow, focusBoxShadow);
  })(props);
};
var trackCSS = function trackCSS(props) {
  return (0, _styledToken.default)('Range.Track.width', function (width) {
    if (width === void 0) {
      width = '100%';
    }
    return (0, _styledComponents.css)(["", " width:", ";"], (0, _SliderMixin.SliderTrackMixin)(props), width);
  })(props);
};
var tracksCSS = function tracksCSS(props) {
  return (0, _styledToken.default)({
    backgroundColor: 'Slider.trackBackgroundColor',
    borderRadius: 'Range.Tracks.borderRadius'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      borderRadius = _ref.borderRadius;
    return (0, _styledComponents.css)(["&::-webkit-slider-runnable-track{", "}&::-moz-range-track{", "}&::-moz-focus-outer{border:0;}&::-ms-track{", " background:transparent;border-color:transparent;color:transparent;}&::-ms-fill-lower{background:", ";border-radius:", ";}&::-ms-fill-upper{background:", ";border-radius:", ";}"], trackCSS(props), trackCSS(props), trackCSS(props), backgroundColor, borderRadius, backgroundColor, borderRadius);
  })(props);
};

/** @class RangeMixin */
/** @method */
var RangeMixin = function RangeMixin(props) {
  return (0, _styledToken.default)({
    width: 'Range.width',
    marginX: 'Range.marginX',
    marginY: 'Range.marginY',
    border: 'Range.border',
    boxShadow: 'Range.boxShadow.default',
    focusBoxShadow: 'Range.boxShadow.focus',
    focusOutline: 'Range.outline.focus'
  }, function (_ref2) {
    var _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? '100%' : _ref2$width,
      _ref2$marginX = _ref2.marginX,
      marginX = _ref2$marginX === void 0 ? 0 : _ref2$marginX,
      _ref2$marginY = _ref2.marginY,
      marginY = _ref2$marginY === void 0 ? 11 : _ref2$marginY,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? 0 : _ref2$border,
      _ref2$boxShadow = _ref2.boxShadow,
      boxShadow = _ref2$boxShadow === void 0 ? 'none' : _ref2$boxShadow,
      _ref2$focusBoxShadow = _ref2.focusBoxShadow,
      focusBoxShadow = _ref2$focusBoxShadow === void 0 ? 'none' : _ref2$focusBoxShadow,
      _ref2$focusOutline = _ref2.focusOutline,
      focusOutline = _ref2$focusOutline === void 0 ? 'none' : _ref2$focusOutline;
    return (0, _styledComponents.css)(["-webkit-appearance:none;height:auto;width:", ";margin:", "px ", "px;border:", ";box-shadow:", ";&:focus{box-shadow:", ";outline:", ";}", " ", ""], width, marginY, marginX, border, boxShadow, focusBoxShadow, focusOutline, thumbsCSS(props), tracksCSS(props));
  })(props);
};
exports.RangeMixin = RangeMixin;